{
  "max100Characters": "Tối đa 100 ký tự",
  "noSpecialOrNumbers": "Không được chứa ký tự đặc biệt hoặc chữ số",
  "noSpecialCharacters": "Không được chứa ký tự đặc biệt",
  "digitsOnly": "Chỉ nhập chữ số",
  "max30Digits": "Tối đa 30 chữ số",
  "max254Characters": "Tối đa 254 ký tự",
  "max15Digits": "Tối đa 15 chữ số",
  "exactly16Digits": "Vui lòng nhập đúng 16 chữ số",
  "fiveToTenDigits": "Vui lòng nhập từ 5 đến 10 chữ số",
  "accountAlreadyAdded": "{{method}} này đã được thêm, vui lòng nhập lại",
  "qrCodeNotFound": "Không tìm thấy mã QR nhận tiền",
  "uploadReceivingCode": "Tải mã QR nhận tiền lên",
  "reupload": "Tải lại",
  "confirm": "Xác nhận",
  "namePlaceholder": {
    "bank": "Nhập tên chủ thẻ",
    "alipay": "Nhập tên đã xác minh Alipay",
    "wechat": "Nhập tên đã xác minh WeChat",
    "ermb": "Nhập tên đã xác minh ví kỹ thuật số",
    "qq": "Nhập tên đã xác minh QQ"
  },
  "accountLabel": {
    "bank": "Số thẻ ngân hàng",
    "alipay": "Tài khoản Alipay",
    "wechat": "Số điện thoại WeChat",
    "ermb": "Mã ví",
    "qq": "Số QQ"
  },
  "maximumTwenty": "Chỉ có thể thiết lập tối đa 20 phương thức",
  "title": "Phương thức nhận và thanh toán",
  "transactionPasswordIncorrect": "Mật khẩu giao dịch không đúng",
  "retryMinutes": "{{count}} phút",
  "retryHours": "{{count}} giờ",
  "transactionPasswordLocked": "Mật khẩu giao dịch đã bị khóa tạm thời. Vui lòng thử lại sau hoặc đặt lại mật khẩu giao dịch.",
  "transactionPasswordLockedUntil": "Mật khẩu giao dịch đã bị khóa tạm thời. Hãy thử lại sau {{delay}} hoặc đặt lại mật khẩu giao dịch.",
  "transactionPasswordLastAttempt": "Mật khẩu giao dịch không đúng, chỉ còn 1 lần thử; nhập sai lần nữa sẽ bị khóa tạm thời.",
  "transactionPasswordAttemptsRemaining": "Mật khẩu giao dịch không đúng, còn {{count}} lần thử",
  "refresh": "Làm mới",
  "selectedReceivingMethodCount": "Đã chọn {{count}} phương thức nhận tiền",
  "add": "Thêm",
  "matchingNameHint": "Chỉ hiển thị phương thức thanh toán có tên khớp với tên đã xác minh của bạn. Nếu không có, hãy thêm phương thức dùng cùng tên đã xác minh.",
  "noPaymentMethods": "Chưa có phương thức nhận hoặc thanh toán",
  "addPaymentMethod": "Thêm phương thức nhận hoặc thanh toán",
  "selected": "Đã chọn",
  "added": "Đã thêm phương thức nhận hoặc thanh toán",
  "addFailed": "Không thể thêm phương thức nhận hoặc thanh toán",
  "deleted": "Đã xóa phương thức nhận hoặc thanh toán",
  "deleteFailed": "Không thể xóa phương thức nhận hoặc thanh toán",
  "updated": "Đã cập nhật phương thức nhận hoặc thanh toán",
  "updateFailed": "Không thể cập nhật phương thức nhận hoặc thanh toán",
  "confirmDelete": "Xác nhận xóa phương thức nhận hoặc thanh toán",
  "confirmDeleteDescription": "Bạn có chắc muốn xóa phương thức nhận hoặc thanh toán này không? {{lastOne}}",
  "lastPaymentMethod": "Đây là phương thức nhận hoặc thanh toán cuối cùng của bạn.",
  "delete": "Xóa",
  "receivingCodeLabel": {
    "alipay": "Mã QR nhận tiền Alipay",
    "wechat": "Mã QR nhận tiền WeChat",
    "qq": "Mã QR nhận tiền QQ"
  }
}
